import CompLayout from "@/pcomponents/comp/layout/layout";
import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import SelectBoxBar from "@/pcomponents/common/crud/write/select_box_bar";
import CoreListArea from "@/pages/comp/plan/video/acommon/corse/list";
import CoreListShareArea from "@/pages/comp/plan/video/acommon/corse_share/list";
import VideoUseDetailListArea from "@/pages/comp/plan/video/acommon/history/use_detail/list";
import RequestListArea from "@/pages/comp/plan/video/acommon/request/list";

function VideoListUnionPage() {
  let user = useSelector((state: any) => state.user);
  const show_tab_arr = [
    { text: "동영상강의", value: "core" },
    { text: "신청보기", value: "request" },
    { text: "사용이력", value: "history" },
  ];
  if(user.comp_sort_detail=="sntbr"){
    show_tab_arr.push({ text: "공유", value: "share" });
  }
  const [show_tab, set_show_tab] = useState("core");

  let view_component: any = "";
  if (show_tab == "core") {
    view_component = <CoreListArea></CoreListArea>;
  } else if (show_tab == "request") {
    view_component = <RequestListArea></RequestListArea>;
  }else if (show_tab == "history") {
    view_component = <VideoUseDetailListArea></VideoUseDetailListArea>;
  }else if (show_tab == "share") {
    view_component = <CoreListShareArea></CoreListShareArea>;
  }

  return (
    <CompLayout>
      <div>
        <SelectBoxBar
          valueTextArr={show_tab_arr}
          value={show_tab}
          name="show_tab"
          on_change={(inData: any) => {
            set_show_tab(inData.value);
          }}
          is_same_value_empty={false}
        ></SelectBoxBar>
      </div>
      <div className="mt-1">
        {view_component}
      </div>
    </CompLayout>
  );
}

export default VideoListUnionPage;